import { industryStatsService } from '../services/industryStats.service';

const state = {
  dates: {},
  industryData: {}
};

const actions = {
  setDates({ commit }, {startDate, endDate, datasetName}) {
    commit('changeDates', {startDate, endDate, datasetName});
  },

  getData({ dispatch, commit, state }, datasetName) {
    return industryStatsService.getDataset(state.dates[datasetName], datasetName)
      .then(data => {
        commit('changeData', {
          datasetName,
          data
        });
      })
      .catch(() => dispatch('alert/error', 'Unable to get chart data', { root: true }));
  }
};

const mutations = {
  changeData(state, payload) {
    state.industryData[payload.datasetName] = payload.data;
  },

  changeDates(state, payload) {
    state.dates[payload.datasetName] = {
      start_date: payload.startDate.toISO({ includeOffset: false }),
      end_date: payload.endDate.toISO({ includeOffset: false })
    };
  }
};

export const industry = {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/industry.module.js